module.exports = __webpack_public_path__ + "static/dean-witcraft-258a46fc3870291191c317edf10fee7c.jpg";